export type { TimestampProps, TimestampSlots, TimestampState } from './components/Timestamp/index';
export { Timestamp, timestampClassNames, useTimestampStyles_unstable } from './components/Timestamp/index';
